import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

/*
const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
};
*/

const config = {
  apiKey: "AIzaSyA71iSoiIMXNWkSiWaEXSMcaaJBgqyXxws",
  authDomain: "truenorth-software.firebaseapp.com",
  databaseURL: "https://truenorth-software.firebaseio.com",
  projectId: "truenorth-software",
  storageBucket: "truenorth-software.appspot.com",
  messagingSenderId: "895695071574",
  appId: "1:895695071574:web:07495367c33e2efcd8cef7",
  measurementId: "G-ZXLPZVP9WC"
};

class Firebase {
  constructor() {
    app.initializeApp(config);

    this.auth = app.auth();
    this.db = app.database();
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password =>
    this.auth.currentUser.updatePassword(password);

  // *** User API ***

  user = uid => this.db.ref(`users/${uid}`);
  license = id => this.db.ref(`licenses/${id}`);
  licenses = () => this.db.ref('licenses');
  users = () => this.db.ref('users');
}

export default Firebase;
